import { EXIT_TYPES, EXIT_TYPE_LABELS, type ExitType } from '@/lib/exitTypes'

export interface ExitTypeSelectProps {
  id: string
  /** Empty until chosen when the form has no default. */
  value: ExitType | ''
  onChange: (value: ExitType) => void
  disabled?: boolean
}

/** Required "Exit type" choice for every action that ends an employment. */
export function ExitTypeSelect({
  id,
  value,
  onChange,
  disabled,
}: ExitTypeSelectProps): React.ReactElement {
  return (
    <div>
      <label
        htmlFor={id}
        className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300"
      >
        Exit type
      </label>
      <select
        id={id}
        required
        disabled={disabled}
        value={value}
        onChange={(event) => onChange(event.target.value as ExitType)}
        className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
      >
        {value === '' && (
          <option value="" disabled>
            Choose why the employment ends
          </option>
        )}
        {EXIT_TYPES.map((type) => (
          <option key={type} value={type}>
            {EXIT_TYPE_LABELS[type]}
          </option>
        ))}
      </select>
    </div>
  )
}

ExitTypeSelect.displayName = 'ExitTypeSelect'
